import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const projectFile = RepositoryFactory.get("projectFile");
const addOns = RepositoryFactory.get("addOns");
const events = RepositoryFactory.get("events");
export default {
  getProjectDetails({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await projectFile.getProjecDetails(payload);
        commit("SELECTED_PROJECT", data.data.data[0]);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAllProject({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await projectFile.getProjecDetails(payload);
        commit("SELECTED_PROJECT", data.data.data[0]);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAddOnsUsageDetails({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await projectFile.getAddOnsDetails(payload);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAddOns({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await addOns.getAddOns(payload);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  getEvents({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await events.getEvents(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
